import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import medoffice from "../../practices_images/medical-offices.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const MedicalOffices = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    <div className="cap-container">
    <h1>Medical Offices</h1>

    <div className="cap-section">
        {/* Text Content */}
        <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Strengthening the foundation of outpatient care</h3>
            <p>
              Medical offices are the backbone of outpatient healthcare. They support a wide range of services, from routine visits and preventive care to ongoing management of chronic conditions. These environments must operate efficiently while maintaining accurate documentation, regulatory compliance, and financial stability.
            </p>
            <p>
              We partner with medical offices to help them build strong operational foundations that support consistent, high quality care.
            </p>

            <h3>The Operating Environment</h3>
            <p>
              Medical offices operate in fast paced settings where patient flow, documentation accuracy, and financial performance are closely linked. Administrative demands continue to grow, while reimbursement models and regulatory requirements become more complex.
            </p>
            <p>
              Without aligned systems and processes, inefficiencies can impact both patient experience and organizational sustainability.
            </p>

            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help medical offices strengthen the operational and financial processes that support day to day care delivery.
              </p>
              <p>
                Our work focuses on improving workflows across administrative and clinical teams, reinforcing documentation and billing accuracy, improving financial visibility, and supporting reliable use of technology systems. We also help organizations maintain compliance and protect sensitive patient data through disciplined IT and security practices.
              </p>
              <p>
                Our approach is practical and grounded in the realities of outpatient care.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Enabling Stability and Efficiency">
              <p>
                Our goal is to help medical offices operate with clarity and control.
              </p>
              <p>
                By reducing administrative friction and strengthening financial foundations, we support more predictable performance, improved cash flow, and a smoother experience for patients and staff. This allows care teams to focus on delivering care while leadership maintains operational oversight.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Looking Ahead">
              <p>
                As outpatient care continues to evolve, strong operational foundations remain essential.
              </p>
              <p>
                We work with medical offices to build the structure, discipline, and resilience required to adapt and grow.
              </p>
              <p>
                Let’s begin a conversation about how your medical office can move forward with confidence and purpose.
              </p>
            </CollapsibleSection>
        </div>

        {/* Image Section */}
        <div className="image-container">
        {<img src={medoffice} alt="Medical Offices" />}
        </div>
    </div>
    </div>

  </motion.div>
  );
};

export default MedicalOffices;
